import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';

const STORAGE_REMEMBER = 'licitapro_remember_email';

export default function Login() {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [verSenha, setVerSenha] = useState(false);
  const [lembrar, setLembrar] = useState(false);
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const salvo = localStorage.getItem(STORAGE_REMEMBER);
    if (salvo) {
      setEmail(salvo);
      setLembrar(true);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    setLoading(true);

    try {
      await login(email, senha);
      if (lembrar) {
        localStorage.setItem(STORAGE_REMEMBER, email);
      } else {
        localStorage.removeItem(STORAGE_REMEMBER);
      }
      navigate('/', { replace: true });
    } catch (err) {
      setErro(
        err.response?.data?.error ||
        err.response?.data?.mensagem ||
        err.response?.data?.message ||
        'Erro ao fazer login. Verifique suas credenciais.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={handleSubmit}>
        <div className="login-logo">
          <h1>LicitaPRO</h1>
        </div>
        <p className="login-subtitle">Entrar na sua conta</p>

        {erro && <div className="login-error">{erro}</div>}

        <div className="login-field">
          <label htmlFor="email">E-mail</label>
          <input
            id="email"
            type="email"
            placeholder="seu@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoFocus={!email}
            autoComplete="email"
          />
        </div>

        <div className="login-field">
          <label htmlFor="senha">Senha</label>
          <div className="login-input-wrap">
            <input
              id="senha"
              type={verSenha ? 'text' : 'password'}
              placeholder="••••••••"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              required
              autoFocus={!!email}
              autoComplete="current-password"
            />
            <button
              type="button"
              className="login-toggle-senha"
              onClick={() => setVerSenha(!verSenha)}
              aria-label={verSenha ? 'Ocultar senha' : 'Mostrar senha'}
              tabIndex={-1}
            >
              {verSenha ? <FiEyeOff /> : <FiEye />}
            </button>
          </div>
        </div>

        <div className="login-actions-row">
          <label className="login-checkbox">
            <input
              type="checkbox"
              checked={lembrar}
              onChange={(e) => setLembrar(e.target.checked)}
            />
            <span>Lembrar de mim</span>
          </label>
          <Link to="/esqueci-senha" className="login-link-secondary">
            Esqueci minha senha
          </Link>
        </div>

        <button className="login-btn" type="submit" disabled={loading}>
          {loading ? 'Entrando...' : 'Entrar'}
        </button>

        <div className="login-divider"><span>ou</span></div>

        <Link to="/cadastro" className="login-btn-outline">
          Criar conta
        </Link>
      </form>
    </div>
  );
}
